/**
 * 子账号注册/登录为 /sub/auth/*，与主站同前端；VITE_IS_SUB_PORTAL=true 时仅多一层「根进子账号登录 + 侧栏子账号壳」
 */
export const isSubPortal = import.meta.env.VITE_IS_SUB_PORTAL === 'true'

const trimTrailingSlash = (value = '') => value.replace(/\/+$/, '')

export const subPortalBaseURL = trimTrailingSlash(import.meta.env.VITE_SUB_PORTAL_BASE_URL || '')
export const mainPortalBaseURL = trimTrailingSlash(import.meta.env.VITE_MAIN_PORTAL_BASE_URL || '')

const getOrigin = (url) => {
  if (!url) return ''
  try {
    return new URL(url).origin
  } catch {
    return ''
  }
}

export const subPortalOrigin = getOrigin(subPortalBaseURL)
export const mainPortalOrigin = getOrigin(mainPortalBaseURL)
export const isPortalDomainConfigReady = Boolean(subPortalOrigin && mainPortalOrigin)

export const isCurrentOrigin = (origin) => {
  if (!origin || typeof window === 'undefined') return false
  return window.location.origin === origin
}

const PORTAL_HANDOFF_HASH = '_ph'

const encodeHandoffPayload = (payload) => {
  return btoa(JSON.stringify(payload))
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=+$/, '')
}

const decodeHandoffPayload = (encoded) => {
  const normalized = encoded.replace(/-/g, '+').replace(/_/g, '/')
  const padding = normalized.length % 4 === 0 ? '' : '='.repeat(4 - (normalized.length % 4))
  return JSON.parse(atob(normalized + padding))
}

/** 构建跨域跳转 URL（token 经 hash 一次性传递，不发给服务端） */
export const buildPortalRedirectURL = (targetOrigin, path, credentials) => {
  const url = new URL(path || '/', targetOrigin)
  if (credentials?.access_token) {
    url.hash = `${PORTAL_HANDOFF_HASH}=${encodeHandoffPayload({
      access_token: credentials.access_token,
      token_type: credentials.token_type || 'Bearer'
    })}`
  }
  return url.toString()
}

/** 读取并清除 URL 中的跨域 handoff token */
export const consumePortalHandoff = () => {
  if (typeof window === 'undefined') return null

  const rawHash = window.location.hash.replace(/^#/, '')
  if (!rawHash.startsWith(`${PORTAL_HANDOFF_HASH}=`)) return null

  try {
    const payload = decodeHandoffPayload(rawHash.slice(PORTAL_HANDOFF_HASH.length + 1))
    if (!payload?.access_token) return null

    const cleanUrl = window.location.pathname + window.location.search
    window.history.replaceState(null, '', cleanUrl)

    return {
      access_token: payload.access_token,
      token_type: payload.token_type || 'Bearer'
    }
  } catch {
    return null
  }
}

/** 清除当前域登录态后跳转到目标域（避免子/主域 localStorage 互相污染） */
export const redirectCrossPortal = (targetOrigin, path, userStore) => {
  const credentials = userStore.isLoggedIn
    ? { access_token: userStore.accessToken, token_type: userStore.tokenType }
    : null

  userStore.logout()

  window.location.replace(
    buildPortalRedirectURL(targetOrigin, path, credentials)
  )
}
